import React, { useState, useEffect } from 'react';
import { Box, TextField, Button, DialogContent } from '@mui/material';
import { GGDialog, GGDialogTitle } from './StyledDialogs';
import { clampDmPartySize, clampDmPartyLevel } from '../../utils/dmPartyDefaults';

export default function DmPartySettingsModal({
  open,
  onClose,
  partySize: partySizeProp,
  partyLevel: partyLevelProp,
  onSave,
}) {
  const [partySize, setPartySize] = useState(String(partySizeProp));
  const [partyLevel, setPartyLevel] = useState(String(partyLevelProp));

  useEffect(() => {
    if (open) {
      setPartySize(String(partySizeProp));
      setPartyLevel(String(partyLevelProp));
    }
  }, [open, partySizeProp, partyLevelProp]);

  const handleSave = () => {
    const size = clampDmPartySize(parseInt(partySize, 10));
    const level = clampDmPartyLevel(parseInt(partyLevel, 10));
    onSave?.({ partySize: size, partyLevel: level });
    onClose?.();
  };

  return (
    <GGDialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <GGDialogTitle>Party Details</GGDialogTitle>
      <DialogContent sx={{ pt: 3, pb: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
          <TextField
            label="Party size"
            type="number"
            value={partySize}
            onChange={(e) => setPartySize(e.target.value)}
            inputProps={{ min: 1, max: 10 }}
            fullWidth
          />
          <TextField
            label="Party level"
            type="number"
            value={partyLevel}
            onChange={(e) => setPartyLevel(e.target.value)}
            inputProps={{ min: 1, max: 20 }}
            fullWidth
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 1 }}>
            <Button onClick={onClose} color="inherit">
              Cancel
            </Button>
            <Button onClick={handleSave} variant="contained" color="primary">
              Save
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </GGDialog>
  );
}
